<app-topbar></app-topbar>

<app-active-booking-badge *ngIf="!isTvScreen"></app-active-booking-badge>

<div class="htz-highlights-content">
  <!--//region NOW -->
  <div class="row hp-content-padding">
    <div class="column small-12 small-12 large-12">
      <div class="hp-content">
        <div class="hp-content-title">{{'PRESENTLY'| translate}}</div>
      </div>
      <div class="htz-no-data-available" *ngIf="highlights.now.length <= 0">
        {{ 'NO_ACTIVITY_SCHEDULED' | translate }}
      </div>
      <div class="row" *ngIf="highlights.now.length >= 1">
        <div class="small-12 small-12 large-6" *ngFor="let highlight of highlights.now">
          <div class="hp-row highlight-item" (click)="openActivity(highlight)">
            <div class="">
              <div class="hp-content-img-container">
                <div class="inner"
                     [ngStyle]="{ backgroundImage: 'url('+ (tasksDictionary[highlight.idActivity]?.photo | apiasset | defaultAsset:'DEFAULT_IMAGE_16_9' )+ ')' }"></div>
              </div>
              <div class="hp-content-hr"></div>
              <div class="hp-content-txt-container">
                <div class="hp-content-first-txt">{{ highlight.activity}}</div>
                <div class="hp-content-second-txt">{{highlight.room}}</div>
                <div class="hp-content-third-txt" *ngIf="highlight.employee">
                  {{highlight.employee}}
                </div>
                <div class="hp-content-third-txt">
                  {{highlight.placesTaken}}/{{highlight.placesMax}}
                </div>
              </div>

              <div class="hp-content-time-next">
                <div class="hp-hour">{{highlight.start | time}}</div>
                <div class="hp-duration">{{highlight.duration}}'</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--//endregion-->


  <!--//region NEXT-->
  <div class="row hp-content-padding">
    <div class="column small-12 small-12 large-12">
      <div class="hp-content">
        <div class="hp-content-title">{{'LATER'| translate}}</div>
      </div>
      <div class="htz-no-data-available" *ngIf="highlights.later.length <= 0">
        {{ 'NO_ACTIVITY_SCHEDULED' | translate }}
      </div>
      <div class="row" *ngIf="highlights.later.length >= 1">
        <div class="small-12 small-12 large-6" *ngFor="let highlight of highlights.later">
          <div class="hp-row highlight-item" (click)="openActivity(highlight)">
            <div>
              <div class="hp-content-img-container">
                <div class="inner"
                     [ngStyle]="{ backgroundImage: 'url('+ (tasksDictionary[highlight.idActivity]?.photo | apiasset | defaultAsset:'DEFAULT_IMAGE_16_9' )+ ')' }"></div>
              </div>
              <div class="hp-content-hr"></div>
              <div class="hp-content-txt-container">
                <div class="hp-content-first-txt">{{ highlight.activity}}</div>
                <div class="hp-content-second-txt">{{highlight.room}}</div>
                <div class="hp-content-third-txt" *ngIf="highlight.employee">
                  {{highlight.employee}}
                </div>
                <div class="hp-content-third-txt">
                  {{highlight.placesTaken}}/{{highlight.placesMax}}
                </div>
              </div>

              <div class="hp-content-time-next">
                <div class="hp-hour">{{highlight.start | time}}</div>
                <div class="hp-duration">{{highlight.duration}}'</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--//endregion-->


  <!--//region SHOW_ALL_TASKS-->
  <div class="row hp-content-end-title">
    <div class="column small-12 small-12 large-12">
      <a [routerLink]="['planning']">
        {{'SEE_THE_SCHEDULE_FOR_THE_WHOLE_WEEK' | translate}}
        <span class="flex"></span>
        <img src="./assets/img/dbl-chevron-right.svg" width="36">
      </a>
    </div>
  </div>
  <!--//endregion-->
</div>
